import React from 'react'
import { useLocation } from 'react-router-dom'
import ContentArea from '../components/ContentArea'
import Video from '../components/Video'

function VideoPage() {
    const location = useLocation()
    const splitUrl = location.pathname.split(`/`)
    const videoNameUrl = splitUrl[[splitUrl.length - 1]]
    let accountId = ``
    let videoId = ``
    let videoName = ``
    switch (videoNameUrl) {

        case `egostrengthening`:
            accountId = "3303963089001"
            videoId = "6315970386112"
            videoName = "Ego Strengthening"
            break

        case `selfhypnosis`:
            accountId = "3303963089001"
            videoId = "6315970778112"
            videoName = "Self Hypnosis"
            break


        case `chairyoga`:
            accountId = "3303963089001"
            videoId = "6044128786001"
            videoName = 'Chair Yoga'
            break

        case `standingyoga`:
            accountId = "3303963089001"
            videoId = "6044122032001"
            videoName = "Standing Yoga"
            break

        case `qigong`:
            accountId = "3303963089001"
            videoId = "6044122697001"
            videoName = "Qigong"
            break

        default:
            return


    }
    return (
        <ContentArea transparent shadowless fullsize>
            <Video
                videoName={videoName}
                accountId={accountId}
                videoId={videoId}
            />
        </ContentArea>
    )
}

export default VideoPage



